import React, { useEffect } from "react"
import BaseContainer from "../../Common/BaseContainer"
import UserInfoForm from "../UserInfoForm"
import UserPasswordForm from "../UserPasswordForm"
import { getSelfProfileInfo } from "../../../store/entities/Profile/Profile.actions"
import HelmetComponent from "../../Common/Helmet/"
import { useDispatch } from "react-redux"

const AccountSettings = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getSelfProfileInfo())
  }, [])

  return (
    <div className={"accountSettingsContainer editContainer "}>
      <HelmetComponent title="Account Settings - TeachOn" />
      <BaseContainer title={"Account settings"} displayLogo={false}>
        <UserInfoForm />
        <UserPasswordForm />
      </BaseContainer>
    </div>
  )
}

export default AccountSettings
